import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Layout, GetInfo, RaceMenu } from "../components";

const RaceRoutes = () => {
  const { city, slug } = useParams();
  const [contentId, setContentId] = useState({ banner: 0, content: 0 });
  const [newCity, setNewCity] = useState([]);
  const [menuLinks, setmenuLinks] = useState([]);

  useEffect(() => {
    const urlDictionary = {
      "2023-punta-cana": {
        resumen: {
          banner: 69,
          content: 145,
        },
        prologo: {
          banner: 69,
          content: 148,
        },
        "etapa-1": {
          banner: 69,
          content: 149,
        },
        "etapa-2": {
          banner: 69,
          content: 150,
        },
        "etapa-3": {
          banner: 69,
          content: 151,
        },
        "etapa-4": {
          banner: 69,
          content: 152,
        },
      },
      "2024-punta-cana": {
        resumen: {
          banner: 69,
          content: 155,
        },
        "etapa-1": {
          banner: 69,
          content: 157,
        },
        "etapa-2": {
          banner: 69,
          content: 158,
        },
        "etapa-3": {
          banner: 69,
          content: 159,
        },
        "etapa-4": {
          banner: 69,
          content: 160,
        },
        "etapa-5": {
          banner: 69,
          content: 156,
        },
      },
      "2025-punta-cana": {
        informacion: {
          banner: 76,
          content: 146,
        },
      },
    };

    const cityUrl = urlDictionary[city];
    setContentId(cityUrl[slug]);

    setmenuLinks(Object.keys(cityUrl));
    setNewCity(city);
  }, [slug, city]);

  return (
    <div className="RaceRoutes">
      <Layout bannerId={contentId.banner}>
        <RaceMenu menuLinks={menuLinks} city={newCity} />
        <div className="container">
          <GetInfo id={contentId.content} />
        </div>
      </Layout>
    </div>
  );
};

export default RaceRoutes;
